<template>
  <div class="page">  
    <div class="alerts">

      <div class="top">
        <div>Alerts {{filteredAlerts.length}} of {{alerts.length}}</div>
        <!-- <div>
          Sort:
          <select v-model="alertsFilter.sortAttr">
            <option value="type">Type</option>
            <option value="state">State</option>
          </select>
          <input type="checkbox" id="filterCheckbox" v-model="alertsFilter.sortReverse">
          <label for="filterCheckbox">reverse</label>
        </div> -->
        <!-- <div>
          Filter:
          <select v-model="alertsFilter.type">
            <option value="">All</option>
            <option value="host">Host</option>
            <option value="domain">Domain</option>
            <option value="application">Application</option>         
          </select>
          
        </div> -->
        <div>
          <!--<span v-show="updateProgress < 100">Updating {{updateProgress}}% </span>-->
          <button @click="refreshAlerts">Refresh</button>
        </div>
      </div>
      <!-- <Alert v-for="alert in filteredAlerts" :key="alert.id" :alert="alert"/> -->
      <Alert v-for="alert in alerts" :key="alert.id" :alert="alert"/>
    </div>

    <!--<div class="assets">
      <b>Assets</b>
      <div class="top">
        <div>
          <button id="refreshAssetsBtn" @click="refreshAssets">Refresh</button>
        </div>
      </div>
      <Asset v-for="asset in assets" :key="asset.id" :asset="asset"/>
    </div> -->
  </div>


</template>

<style>
</style>

<script>
import { mapState } from 'vuex'
import Alert from '@/components/Alert.vue'  

export default {
  name: 'alerts',
  components: {
    Alert
  },
  computed: { 
    filteredAlerts() {
      // // console.log('filteredAssets:', this.assets)
      // if (!this.alerts || !this.alerts.length) return []
      // // Filter according to type and search
      // var alerts = this.alerts.filter(alert => {
      //   if (this.alertsFilter.type && this.alertsFilter.type != alert.type) return false
      //   // if (asset.id.toLowerCase().indexOf(this.assetsFilter.id.toLowerCase()) === -1) return false
      //   return true
      // })
      // // Sort keywords
      // var sortAttr = this.alertsFilter.sortAttr
      // var sortReverse = this.alertsFilter.sortReverse
      // assets.sort(function(a, b) {
      //   // Strings
      //   if (typeof a[sortAttr] === 'string'){
      //     if (sortReverse)
      //       return b[sortAttr].toLowerCase().localeCompare(a[sortAttr].toLowerCase())
      //     return a[sortAttr].toLowerCase().localeCompare(b[sortAttr].toLowerCase())
      //   }
      //   // Other
      //   if (sortReverse)
      //     return a[sortAttr] - b[sortAttr]// Ascending
      //   return b[sortAttr] - a[sortAttr]// Ascending
      // })
      return this.alerts
    },   
    ...mapState([
      'debugMode',
      'account',
      'profile',
      'alerts',
      'alertsFilter'
    ])
  },
  methods: {
    refreshAlerts () {
      if (!this.profile.id) return
      this.$store.dispatch('loadAlerts')
      // console.log('loadAssets:',this.assets)
    }
  },
  watch: {
    profile () {
      this.refreshAlerts()
    }
  },
  mounted () {
    this.refreshAlerts()
  },
  data () {
    return {
      type: 'domain',
      value: ''
    }
  }
}
</script>
